import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  userCounts 
}) => {
  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'Marketing', label: 'Marketing' },
    { value: 'Compliance', label: 'Compliance' },
    { value: 'Legal', label: 'Legal' },
    { value: 'Operations', label: 'Operations' }
  ];

  const roleOptions = [
    { value: '', label: 'All Roles' },
    { value: 'Marketing Creator', label: 'Marketing Creator' },
    { value: 'Compliance Officer', label: 'Compliance Officer' },
    { value: 'Marketing Director', label: 'Marketing Director' },
    { value: 'Legal Reviewer', label: 'Legal Reviewer' }
  ];

  const statusOptions = [
    { value: '', label: 'All Status' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Pending', label: 'Pending' }
  ];

  const hasActiveFilters = filters?.search || filters?.department || filters?.role || filters?.status;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg font-semibold text-foreground">Team Filters</h2>
          <p className="text-sm text-muted-foreground">
            Showing {userCounts?.filtered} of {userCounts?.total} users
          </p>
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            iconName="X"
            iconPosition="left"
            onClick={onClearFilters}
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Input
          type="search"
          placeholder="Search users..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
          className="w-full"
        />

        <Select
          placeholder="Select department"
          options={departmentOptions}
          value={filters?.department}
          onChange={(value) => onFilterChange('department', value)}
        />

        <Select
          placeholder="Select role"
          options={roleOptions}
          value={filters?.role}
          onChange={(value) => onFilterChange('role', value)}
        />

        <Select
          placeholder="Select status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
      </div>
      {hasActiveFilters && (
        <div className="mt-4 flex flex-wrap gap-2">
          {filters?.search && (
            <div className="inline-flex items-center px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              Search: "{filters?.search}"
              <button
                onClick={() => onFilterChange('search', '')}
                className="ml-2 hover:text-primary/80"
              >
                ×
              </button>
            </div>
          )}
          {filters?.department && (
            <div className="inline-flex items-center px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              Department: {filters?.department}
              <button
                onClick={() => onFilterChange('department', '')}
                className="ml-2 hover:text-primary/80"
              >
                ×
              </button>
            </div>
          )}
          {filters?.role && (
            <div className="inline-flex items-center px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              Role: {filters?.role}
              <button
                onClick={() => onFilterChange('role', '')}
                className="ml-2 hover:text-primary/80"
              >
                ×
              </button>
            </div>
          )}
          {filters?.status && (
            <div className="inline-flex items-center px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              Status: {filters?.status}
              <button
                onClick={() => onFilterChange('status', '')}
                className="ml-2 hover:text-primary/80"
              >
                ×
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterControls;